module.exports = __webpack_public_path__ + "img/card-generic.4dc3fdac.png";